module.exports = __webpack_public_path__ + "static/img/text.8c2782a9.svg";